/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import {
    ON_HANDLE_AGREEMENT,
} from './action';

const initState = {
    agreement: {
      isCheckBox: false
    }
};
/* eslint-disable no-console */
const reducer = (state = initState, action) => {
    switch (action.type) {
        case ON_HANDLE_AGREEMENT: {
            return {
                ...state,
                agreement: {
                  ...state.agreement,
                  ...action.data
                }
            };
        }
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/views/Agreement/state/reducer.js